import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import "./TrustSection.css";

function TrustSection() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="landing-section landing-trust-section">
      <motion.div
        className="landing-trust-box"
        initial={prefersReducedMotion ? false : { opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.6 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      >
        <h2>Magyar éttermeknek, magyar csapat által</h2>
        <p>
          A Tablify-t magyar vendéglátósok mindennapi problémáira építettük.
        </p>

        <div className="landing-trust-badges">
          <div className="landing-trust-badge">
            <span aria-hidden="true">🔒</span> Biztonságos fizetés (Stripe)
          </div>
          <Link to="/privacy" className="landing-trust-badge">
            GDPR-kompatibilis adatkezelés
          </Link>
        </div>
      </motion.div>
    </section>
  );
}

export default TrustSection;
